import { WBBox, WBTypography } from '@admiin-com/ds-web';
import AdmiinLogo from '../../../components/AdmiinLogo/AdmiinLogo';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../../../components';
import OnboardingBusinessCreateForm from './OnboardingBusinessCreateForm';

const OnboardingBusinessCreate = () => {
  const { t } = useTranslation();
  return (
    <PageContainer
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        paddingY: 6,
      }}
    >
      <WBBox
        sx={{
          mb: { md: 5, xs: 1 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <AdmiinLogo />
      </WBBox>
      <WBTypography variant="h3" mt={3}>
        {t('onboardingBusinessCreateTitle', { ns: 'onboarding' })}
      </WBTypography>

      <WBTypography
        variant="body2"
        mb={[3, 15]}
        textAlign="center"
        color="text.secondary"
      >
        {t('onboardingBusinessCreateBody', { ns: 'onboarding' })}
      </WBTypography>
      <OnboardingBusinessCreateForm />
    </PageContainer>
  );
};
export default OnboardingBusinessCreate;
